import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import axios from 'axios'

const roots = document.querySelectorAll('[id^="vehicle-search-"]')

// Find all instances
roots.forEach((root) => {

	// Pass dataset params to App
	const params = root.dataset;

	const filter = params.filter ? params.filter : false
	const headless = params.headless === 'true' ? true : false
	const hide_no_results = params.hide_no_results === 'true' ? true : false;
	const show_all_element_selector = params.show_all_element_selector || false;
	const subscription_url = params.subscription_url  || '/'
	// Accepts both data-monitoring_url and data-monitoring-url
	const monitoring_url = params.monitoring_url || params.monitoringUrl || false
	const endpoint = params.endpoint ? params.endpoint : process.env.REACT_APP_WAYKE_API_URL
	let base_path = params.base_path  || '/'

	const client = axios.create({
		baseURL: endpoint,
		timeout: 10000,
		headers: {
			'Access-Control-Allow-Origin': '*',
			'Content-Type': 'application/json'
		}
	});

	// No trailing /
	base_path = base_path.replace(/\/$/, '')

	ReactDOM.render(<App 
		{ ...{
			path: base_path,
			container: root,
			filter,
			headless,
			hide_no_results,
			show_all_element_selector,
			subscription_url,
			monitoring_url,
			client
		}}
	/>, root)
})
